export function featuresListSlider() {
    const $window = $(window);
    const $slider = $(".features-list.has-slider");

    $window.on("load resize", function () {
        $slider.each(function () {
            let $this = $(this);
                if ($window.innerWidth() >= 1024) {
                    if ($this.hasClass("slick-initialized")) {
                        setTimeout(function () {
                            $this.slick('refresh');
                            $this.slick('unslick');
                        }, 500);
                    }
                } else {
                    if (!$this.hasClass("slick-initialized")) {
                        $this.slick({
                            slidesToScroll: 1,
                            slidesToShow: 1.2,
                            infinite: false,
                            arrows: false,
                            dots: true,
                            mobileFirst: true,
                            responsive: [
                                {
                                    breakpoint: 567,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 1
                                    }
                                },
                            ]
                        });
                    }
                }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/featuresListSlider.js